import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { SpeedBumpImage, Wrapper } from './SpeedBumpTile.styles'
import { useRouter } from 'next/router'

const SpeedBumpTile: React.FC<{ image: string }> = ({ image }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  const router = useRouter()

  return (
    <Wrapper data-testid="speedbump" onClick={() => router.push('/en/things-to-do/winter-experiences')}>
      <SpeedBumpImage baseUrl={baseUrl} image={image} />
    </Wrapper>
  )
}

export default SpeedBumpTile
